var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.status === 'Success')?_c('ordc-01-complete-component',{attrs:{"confirmPayPostResponse":_vm.confirmPayPostResponse}}):_vm._e(),(_vm.status === 'Fail')?_c('ordc-01-error-component'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }